import { checkRoleIsAdmin } from "@/router"

// KHÔNG removeChild node khỏi DOM: Vue 3 vẫn giữ vnode/anchor trỏ tới node đã gỡ,
// lần patch kế tiếp (v-if mount cạnh node đó / keyed diff) insertBefore vào anchor
// đã detach -> NotFoundError rồi "Cannot read properties of null (reading 'insertBefore')"
// lặp vô hạn, vỡ cả trang (chỉ dính với user KHÔNG phải admin — admin return sớm).
// Thiếu quyền -> ẨN element (display:none). Quyền thật vẫn do backend gác.
function hideEl(el) {
  el.style.display = "none"
  el.setAttribute("data-no-permission", "")
}

function permission(el, binding) {
  const { value } = binding
  const else_per = binding.arg
  const temp = window.localStorage.getItem("user")
  const user = temp?JSON.parse(temp) : undefined as any
  const listPermission = user?.permissions?.filter(item => item.name == value[1]) as any
  if(checkRoleIsAdmin()) {
    return true
  }
  if(listPermission && listPermission.length!=0) {
    const permissions  = listPermission[0].permissions
    if(permissions && permissions instanceof Array) {
      if (value && value.length > 0) {
        const permissionRoles = [value[0]]
        const hasPermission = permissions.some(role => {
          return permissionRoles.includes(role)
        })
        if (!hasPermission) {
          if(else_per) {
            return true
          }
          else {
            hideEl(el)
          }
        }
      } else {
        throw new Error(`need permission! Like v-permission="['VIEw','name']"`)
      }
    }
  }
  else {
    if(else_per) {
      return true
    }
    else {
      hideEl(el)
    }
  }
}
function role (el, binding) {
  const { value } = binding
  const temp = window.localStorage.getItem("user")
  const user = temp?JSON.parse(temp) : {} as any
  const {role} = user
  if(checkRoleIsAdmin()) {
    return true
  }
  if(role) {
    if (value && value instanceof Array) {
      if (value.length > 0) {
        const permissionRoles = value
        const hasPermission = permissionRoles.includes(role)
        if (!hasPermission) {
          hideEl(el)
        }
      }
    } else {
      throw new Error(`need roles! Like v-permission="['admin','editor']"`)
    }
  }
 
}
export default {permission, role}